import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const blockDriver = (id, reason) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: `/driver/block/${id}`,
    data: {
      reason,
    },
  });
